import "./style.css";
import gsap from "gsap";

export default class NavBar {
  static selector = ".s-nav-bar";

  constructor(block) {
    this.block = block;
    this.$li = block.querySelectorAll("li");
    this.$active = block.querySelector('li[data-active="true"]');
    this.$line = block.querySelector(".line");
    this.offset = block.querySelector("ul").getBoundingClientRect().x;
    this.activeIndex = 0;

    this.$li.forEach(($el, index) => {
      if ($el.getAttribute("data-active") === "true") {
        this.activeIndex = index;
      }
    });
  }

  moveLine($el) {
    const { width, x } = $el.getBoundingClientRect();
    gsap.to(this.$line, {
      duration: 0.65,
      ease: "power2.inOut",
      width: width + 32,
      x: x - this.offset - 16,
    });
  }

  onReady() {
    const { width, x } = this.$active.getBoundingClientRect();
    gsap.set(this.$line, { width: width + 32, x: x - this.offset - 16 });

    this.$li.forEach(($el, index) => {
      $el.addEventListener("mouseenter", this.moveLine.bind(this, $el));
      $el.addEventListener(
        "mouseleave",
        this.moveLine.bind(this, this.$active)
      );
    });
  }

  onResize() {
    this.moveLine(this.$active);
  }
}
